// extracted by mini-css-extract-plugin
export default {"wrapper":"Nav-Blocks_wrapper__Tsksq","navBtn":"Nav-Blocks_navBtn__AVwiN","editBtn":"Nav-Blocks_editBtn__s59o0"};